export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8556.8ced4a94.jpg";